import { ArrowButtonDownBold, ArrowButtonUpBold } from '@ha/icons';
import React from 'react';
import { makeStyles } from '@material-ui/core';

import { useIntl } from 'ha/i18n';
import {
  Collapse,
  Divider,
  Chip,
  IconButton,
  ListItemIcon,
  ListItemText,
  MenuList,
  Typography,
} from '@ha/dsl';
import MenuItem from './MenuItem';

import { Menu } from '../utils';

const useStyles = makeStyles(theme => ({
  title: {
    margin: '1rem 1rem 0 1rem',
  },
  divider: {
    padding: '0 1rem',
    margin: '1rem 0',
  },
  chip: {
    marginLeft: '10px',
  },
  chipRoot: {
    background: theme.palette.orange.main,
    color: 'white',
  },
}));

interface Props {
  title: string;
  data: Menu[];
  testId: string;
  hasDivider?: boolean;
}

const MobileDropdownMenu: React.FC<Props> = ({
  title,
  data,
  testId,
  hasDivider,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const intl = useIntl();
  const { T } = intl;
  const classnames = useStyles();

  const toggleDropdown = React.useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  return (
    <React.Fragment>
      <MenuItem onClick={toggleDropdown} data-test-locator={`${testId} Btn`}>
        <ListItemText>
          <Typography.Paragraph textTransform="uppercase">
            {title}
          </Typography.Paragraph>
        </ListItemText>
        <IconButton size="small">
          {isOpen ? (
            <ArrowButtonUpBold fontSize="inherit" />
          ) : (
            <ArrowButtonDownBold fontSize="inherit" />
          )}
        </IconButton>
      </MenuItem>
      <Collapse in={isOpen} timeout="auto">
        <MenuList disablePadding data-test-locator={`${testId} Menu`}>
          {data.map((section, index) => [
            !!index && (
              <div className={classnames.divider}>
                <Divider />
              </div>
            ),
            <div className={classnames.title}>
              <Typography.Caption color="muted">
                {section.title}
                {section.isNew && (
                  <span className={classnames.chip}>
                    <Chip
                      classes={{ root: classnames.chipRoot }}
                      label={T('New')}
                      size="small"
                    />
                  </span>
                )}
              </Typography.Caption>
            </div>,
            section.links.map(link => (
              <MenuItem
                key={link.title}
                to={link.url}
                rel={link.noFollow ? 'no-follow' : undefined}
              >
                <ListItemIcon iconSize="small">{link.icon}</ListItemIcon>
                <ListItemText>{link.title}</ListItemText>
              </MenuItem>
            )),
          ])}
        </MenuList>
      </Collapse>
      {hasDivider && <Divider />}
    </React.Fragment>
  );
};

export default MobileDropdownMenu;
